import { ArrowRight } from "lucide-react";
import { useLeadDialog } from "@/context/LeadDialogContext";

const VARIANTS = {
  primary: "bg-[#111111] text-white hover:bg-[#0B63F6]",
  accent: "bg-[#0B63F6] text-white hover:bg-[#6E56CF] glow-blue",
  light: "bg-white text-[#111111] hover:bg-gray-100",
  outline: "bg-transparent text-[#111111] border border-gray-300 hover:border-[#111111]",
  outlineLight: "bg-transparent text-white border border-white/30 hover:border-white hover:bg-white/5",
};

export default function CtaButton({
  children,
  variant = "primary",
  source = "cta",
  service = "",
  title,
  arrow = true,
  className = "",
  testId = "cta-button",
}) {
  const { openLead } = useLeadDialog();
  return (
    <button
      onClick={() => openLead({ source, service, title: title || (typeof children === "string" ? children : undefined) })}
      data-testid={testId}
      className={`group inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-[15px] font-medium transition-all duration-300 active:scale-[0.98] ${VARIANTS[variant]} ${className}`}
    >
      {children}
      {arrow && <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />}
    </button>
  );
}
